import { StyledSpinner } from './ButtonSpinner.styles';

const ButtonSpinnerWhite = () => {
  return <StyledSpinner src="/svg/loading_white.svg" alt="Spinner icon" aria-label="Loading" />;
};

export default ButtonSpinnerWhite;
